export default __webpack_public_path__ + "static/media/materialui.2b8e37c3.svg";